import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const Section = styled.div`
    padding: 2.5rem 0;
    background-color: ${props => props.theme.colors.tfwBlack3};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* tablets */
        padding: 4.375rem 0;
    }
`

export const Title = styled.h2`
    padding: 0 1.25rem;
    font-family: ${({ theme }) => theme.typography.font.family.yummo};
    font-size: 1.75rem;
    font-weight: bold;
    text-align: ${({ theme }) => theme.style.textAlign.center};
    color: ${({ theme }) => theme.colors.tfwBlack87};
    margin: 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        /* tablets */
        font-size: 2.125rem;
    }
`
